import { EntryKinds } from '@i-ark/models';

/**
 * helper that will apply offsets on moved items and insert clones based on
 * the given user entry
 */
const enrichPageItems = (page, pageEntry) => {
  // separate items into two categories; statically positioned and dynamically
  // positioned ones
  const staticItems = [];
  const dynamicItems = [];
  page.items.forEach(item => {
    const entry = pageEntry?.items[item.id];
    if (entry?.position !== undefined) {
      dynamicItems.push({
        zIndex: entry.zIndex ?? 0,
        item: enrichItem(entry.entry, {
          ...item,
          position: entry.position
        })
      });
    } else {
      staticItems.push(enrichItem(entry?.entry, item));
    }
  });

  // append the list of cloned elements as dynamic items
  pageEntry?.clones.forEach(clone => {
    const item = page.items.find(it => it.id === clone.itemId);
    if (item !== undefined) {
      dynamicItems.push({
        zIndex: clone.zIndex,
        item: enrichItem(clone.entry, {
          ...item,
          id: clone.cloneId,
          position: clone.position
        })
      });
    }
  });

  // append the list of drawn lines as items
  pageEntry?.lines.forEach(line => {
    const entry = pageEntry.items[line.id];
    if (entry?.position !== undefined) {
      dynamicItems.push({
        zIndex: entry.zIndex ?? 0,
        item: enrichItem(entry.entry, {
          ...line,
          position: entry.position
        })
      });
    } else {
      staticItems.push(enrichItem(entry?.entry, line));
    }
  });

  // identify the index of the first input or text element within the sheet, so
  // we can inject legacy canvas drawings directly behind that one
  const indexOfPrioritizedItem = staticItems.findIndex(it => it.kind === "input" || it.kind === "linkHotspot" || it.kind === "speechHotspot" || it.kind === "table" || it.kind === "text");
  const legacyCanvasDrawingsIndex = indexOfPrioritizedItem > -1 ? indexOfPrioritizedItem : staticItems.length;

  // inject legacy canvas drawings directly behind the desired index
  staticItems.splice(legacyCanvasDrawingsIndex, 0, ...(pageEntry?.drawings.map(mapDrawingsToItem) ?? []));
  return [...staticItems,
  // always render legacy canvas drawings on top of static items, but behind
  // all other dynamically positioned elements; that way we know that they
  // will be visible on top of static items, but as we can no longer safely
  // determine where to place them on the z-axis we prefer drawing them behind
  // elements the user can still interact with
  ...(pageEntry?.drawings.map(mapDrawingsToItem) ?? []),
  // sort dynamic items by z-index so that they're ordered correctly based on
  // which the user interacted with lastly
  ...dynamicItems.sort((a, b) => a.zIndex - b.zIndex).map(it => it.item)];
};
function enrichItem(entry, item) {
  switch (entry?.kind) {
    case EntryKinds.LEGACY_CANVAS_SHAPE:
      switch (item.kind) {
        case "legacyCanvasShape":
          return {
            ...item,
            style: {
              ...item.style,
              background: {
                ...item.style.background,
                color: entry.backgroundColor ?? item.style.background.color
              }
            }
          };
        default:
          return item;
      }
    default:
      return item;
  }
}
function mapDrawingsToItem(drawing) {
  return {
    kind: "legacyCanvasDrawing",
    id: drawing.id,
    position: drawing.position,
    size: drawing.size,
    points: drawing.points,
    style: {
      stroke: {
        color: drawing.style.color,
        width: drawing.style.lineWidth
      }
    }
  };
}

export { enrichPageItems };
//# sourceMappingURL=enrichPageItems.js.map
